export default "__VITE_ASSET__D9ud_PUx__"